import script from "./TeleconsultationForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./TeleconsultationForm.vue?vue&type=script&setup=true&lang=ts"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css&external"
import "./TeleconsultationForm.vue?vue&type=style&index=1&id=e52f2814&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e52f2814"]])

export default __exports__